module.exports = __webpack_public_path__ + "static/adambeyer_1-298b224e3e5cfa40dff261ba710dfa12.jpg";